import axios from "axios";
import { applyAuthTokenInterceptor } from "../auth/interceptor";
import { Environment } from "./../../services/env";

export const authenticatedApiClient = axios.create({
  baseURL: Environment.apiUrl,
});

applyAuthTokenInterceptor(authenticatedApiClient);
